export default __webpack_public_path__ + "e812ebe2dc4f929b197bc3a6fe7eb74c.png";